/**
 * Shared constants for the Fyncall Widget SDK
 */

// =============================================================================
// CART & SHIPPING CONSTANTS
// =============================================================================

/**
 * Free shipping threshold in dollars
 */
export const FREE_SHIPPING_THRESHOLD = 75;

/**
 * Minimum business days for delivery estimate
 */
export const DELIVERY_MIN_BUSINESS_DAYS = 3;

/**
 * Maximum business days for delivery estimate
 */
export const DELIVERY_MAX_BUSINESS_DAYS = 5;

/**
 * Hour cutoff for same-day processing (24h format)
 * Orders placed before this hour are processed same day
 */
export const SAME_DAY_PROCESSING_CUTOFF = 14; // 2 PM

/**
 * Default promo discount rate for demo mode (10%)
 */
export const PROMO_DEMO_DISCOUNT_RATE = 0.1;

// =============================================================================
// WEBSOCKET CONSTANTS
// =============================================================================

/**
 * Maximum number of WebSocket reconnection attempts
 */
export const MAX_RECONNECT_ATTEMPTS = 5;

/**
 * Base delay for WebSocket reconnection (ms)
 * Actual delay = BASE * (2 ^ attempt), capped at MAX
 */
export const RECONNECT_BASE_DELAY = 1000;

/**
 * Maximum delay for WebSocket reconnection (ms)
 */
export const RECONNECT_MAX_DELAY = 30000;

// =============================================================================
// PROACTIVE ENGAGEMENT CONSTANTS
// =============================================================================

/**
 * Default delay before showing proactive message (ms)
 */
export const DEFAULT_PROACTIVE_DELAY = 30000;

/**
 * Minimum time between proactive triggers (ms)
 */
export const MIN_TRIGGER_INTERVAL = 60000;

/**
 * Maximum proactive triggers per session
 */
export const MAX_TRIGGERS_PER_SESSION = 3;

// =============================================================================
// UI CONSTANTS
// =============================================================================

/**
 * Default primary color for widget
 */
export const DEFAULT_PRIMARY_COLOR = '#007bff';

/**
 * Default secondary color for widget
 */
export const DEFAULT_SECONDARY_COLOR = '#6c757d';

/**
 * Default border radius for widget elements
 */
export const DEFAULT_BORDER_RADIUS = '12px';

/**
 * Status message display duration (ms)
 */
export const STATUS_MESSAGE_DURATION = 3000;

// =============================================================================
// SESSION CONSTANTS
// =============================================================================

/**
 * Session time-to-live (24 hours in ms)
 */
export const SESSION_TTL_MS = 24 * 60 * 60 * 1000;

/**
 * Session activity timeout for expiry check (ms)
 */
export const SESSION_ACTIVITY_TIMEOUT = SESSION_TTL_MS;

// =============================================================================
// FILE UPLOAD CONSTANTS
// =============================================================================

/**
 * Maximum file size for uploads (10 MB)
 */
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

/**
 * Allowed file types for upload
 */
export const ALLOWED_FILE_TYPES = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/pdf',
    'text/plain'
];
